import React, { useEffect, useMemo, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../_redux/report/kurbanReportAction';
import * as uiHelpers from '../KurbanReportUIHelpers';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    sortCaret,
    toastOption,
} from '../../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../../_metronic/_partials/controls';
import { useKurbanReportUIContext } from '../KurbanReportUIContext';
import { RoleChecker } from '../../../../../../RoleChecker';
import History from '../../../../../../History';
import moment from 'moment'
import KurbanReportDetailUpdateDialogue from '../kurban-report-update-dialog/KurbanReportDetailUpdateDialogue';
import { toast } from "react-toastify"

const KurbanReportTable = ({ history }) => {
    // KurbanReport UI Context
    const kurbanReportUIContext = useKurbanReportUIContext();
    const kurbanReportUIProps = useMemo(() => {
        return {
            queryParams: kurbanReportUIContext.queryParams,
            setQueryParams: kurbanReportUIContext.setQueryParams,
            openEditKurbanReportPage: kurbanReportUIContext.openEditKurbanReportPage,
        };
    }, [kurbanReportUIContext]);

    // Getting curret state of kurbanReport list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.kurbanReport }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading } = currentState;

    const dispatch = useDispatch();
    useEffect(() => {
        //Requset ke Branch Action
        dispatch(actions.fetchKurbanReports(kurbanReportUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [kurbanReportUIProps.queryParams, dispatch, kurbanReportUIProps.queryParams.filter.status]);
    // console.log(entities);
    const allowEdit = RoleChecker('Edit', 'kurban-report');

    const [data, setData] = useState(null)
    const [show, setShow] = useState(false)
    const handleShow = (data) => {
        setShow(true)
        setData(data)
    }
    const handleClose = () => {
        setShow(false)
        setData(null)
    }

    const updateKurbanReport = (data) => {
        const dataDeterminer = (item) => {
            switch (item.status) {
                case "WAITING_PARTNER":
                    return {
                        status: "ACCEPTED_PARTNER",
                        uuid: item.uuid
                    }
                case "ACCEPTED_PARTNER":
                    return {
                        status: "EXECUTED",
                        uuid: item.uuid
                    }
                default:
                    return null
            }
        }

        const dataToSent = dataDeterminer(data)
        console.log(dataToSent)

        if (!dataToSent) {
            toast.error("Status Tidak Dikenali", toastOption)
        } else {
            dispatch(actions.updateStatusKurbanReport(dataToSent)).then((response) => {
                if (response) {

                    toast.success(response.message, toastOption);
                }
                dispatch(actions.fetchKurbanReports(kurbanReportUIProps.queryParams)).then(() => handleClose());
            });
        }

    };

    // Table columns
    const columns = [
        {
            dataField: 'kurban_hid',
            text: 'No. Kurban',
            sort: true,
            sortCaret: sortCaret,
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: columnFormatters.StatusColumnFormatter,
            sort: true,
            sortCaret: sortCaret,
        },
        {
            dataField: 'thk_partner.name',
            text: 'Mitra',
        },
        {
            dataField: 'thk_livestock.name',
            text: 'Hewan Kurban',
        },
        {
            dataField: 'is_merging',
            text: 'Hasil Merging',
            formatter: (cell) => {
                return  (
                    <span>
                        {Boolean(cell) ? "YA" : "TIDAK"}
                    </span> 
                )
            }
        },
        {
            dataField: 'created_at',
            text: 'Tanggal Distribusi',
            formatter: (cell, row) => {
                return moment(cell).format('DD-MM-YYYY')
            }
        },
        {
            dataField: 'updated_at',
            text: 'Terakhir Update',
            formatter: (cell, row) => {
                return moment(cell).format('DD-MM-YYYY')
            }
        },
        {
            dataField: 'action',
            text: 'Aksi',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditKurbanReportPage: kurbanReportUIProps.openEditKurbanReportPage,
                allowEdit,
                handleShow,
                handleClose
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: kurbanReportUIProps.queryParams.pageSize,
        page: kurbanReportUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                onTableChange={(type, tableInfo) => {
                                    getHandlerTableChange(kurbanReportUIProps.setQueryParams, type, tableInfo)
                                    History.push(uiHelpers.queryStringMaker(kurbanReportUIProps.queryParams.filter.name, kurbanReportUIProps.queryParams.filter.email, kurbanReportUIProps.queryParams.filter.role, kurbanReportUIProps.queryParams.filter.is_active, tableInfo.page, tableInfo.sizePerPage, tableInfo.sortField, tableInfo.sortOrder))
                                }}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
            <KurbanReportDetailUpdateDialogue handleClose={handleClose} show={show} data={data} updateStatus={updateKurbanReport} />
        </>
    );
};

export default KurbanReportTable;
